import { getCurrentInstance, computed } from "vue";
const useNumericProp = (key) => {
  const props = getCurrentInstance().props;
  const numericComputed = computed(() => {
    const numeric = props == null ? void 0 : props[key];
    if (numeric === void 0) {
      return numeric;
    }
    return Number(numeric);
  });
  return numericComputed;
};
export {
  useNumericProp as u
};
//# sourceMappingURL=useNumericProp.js.map
